import { render } from "./ai.vue?vue&type=template&id=4a71c8d4&scoped=true"
import script from "./ai.vue?vue&type=script&lang=js"
export * from "./ai.vue?vue&type=script&lang=js"

import "./ai.vue?vue&type=style&index=0&id=4a71c8d4&scoped=true&lang=scss"

import exportComponent from "D:\\project\\2024\\htos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a71c8d4"]])

export default __exports__